export enum actionTypes {
  //fetch Pakages
  FETCH_PACKAGES_REQUEST = "FETCH_PACKAGES_REQUEST",
  FETCH_PACKAGES_SUCCESS = "FETCH_PACKAGES_SUCCESS",
  FETCH_PACKAGES_FAIL = "FETCH_PACKAGES_FAIL",
  //Create Packages
  CREATE_PACKAGE_REQUEST = "CREATE_PACKAGE_REQUEST",
  CREATE_PACKAGE_SUCCESS = "CREATE_PACKAGE_SUCCESS",
  CREATE_PACKAGE_FAIL = "CREATE_PACKAGE_FAIL",
  //Update Packages
  UPDATE_PACKAGE_SUCCESS = "UPDATE_PACKAGE_SUCCESS",
  UPDATE_PACKAGE_FAIL = "UPDATE_PACKAGE_FAIL",
  //Update Packages
  DELETE_PACKAGE_SUCCESS = "DELETE_PACKAGE_SUCCESS",
  DELETE_PACKAGE_FAIL = "DELETE_PACKAGE_FAIL",
  RESET_PACKAGE = "RESET_PACKAGE",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface CreatePackageInput {
  name: string;
  description: string;
  package_type: string;
  package_order: number;
  information: string;
}

export interface UpdatePackageInput {
  package_type: string;
  package_id: string;
  name: string;
  description: string;
  package_order: number;
  information:string;
}

export interface DeletePackageInput {
  package_id: string;
}

export interface CreatePackageError {
  name?: string;
  description?: string;
  package_type?: string;
  package_order?: string;
  information?: string;
}

export interface PackageProps {
  package_type: string;
  created_at: string;
  updated_at: string;
  id: string;
  name: string;
  description: string;
  package_order: number;
  information: string;
}

export interface PackagesPaylodProps {
  packages: PackageProps;
}

//fetch package
export interface FetchPackagesRequestAction {
  type: actionTypes.FETCH_PACKAGES_REQUEST;
}

export interface FetchPackagesSuccessAction {
  type: actionTypes.FETCH_PACKAGES_SUCCESS;
  payload: PackagesPaylodProps[];
}

export interface FetchPackagesFailureAction {
  type: actionTypes.FETCH_PACKAGES_FAIL;
  payload: string;
}

//create package
export interface CreatePackageRequestAction {
  type: actionTypes.CREATE_PACKAGE_REQUEST;
}

export interface CreatePackageSuccessAction {
  type: actionTypes.CREATE_PACKAGE_SUCCESS;
  payload: PackageProps;
}

export interface CreatePackageFailureAction {
  type: actionTypes.CREATE_PACKAGE_FAIL;
  payload: string;
}

//Update package
export interface UpdatePackageSuccessAction {
  type: actionTypes.UPDATE_PACKAGE_SUCCESS;
  payload: PackageProps;
}
export interface UpdatePackageFailAction {
  type: actionTypes.UPDATE_PACKAGE_FAIL;
  payload: string;
}

//Delete package
export interface DeletePackageSuccessAction {
  type: actionTypes.DELETE_PACKAGE_SUCCESS;
  payload: string;
}
export interface DeletePackageFailAction {
    type: actionTypes.DELETE_PACKAGE_FAIL;
    payload: string;
}
export interface ResetPackage {
  type: actionTypes.RESET_PACKAGE;
}

export type PackageActions =
  | FetchPackagesRequestAction
  | FetchPackagesSuccessAction
  | FetchPackagesFailureAction
  | CreatePackageRequestAction
  | CreatePackageSuccessAction
  | CreatePackageFailureAction
  | UpdatePackageSuccessAction
  | UpdatePackageFailAction
  | DeletePackageSuccessAction
  | DeletePackageFailAction
  | ResetPackage
